var _path, _mask;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileNuix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 0.028,
    cy: 48,
    r: 1.032,
    gradientTransform: "matrix(17.2746 0 0 -17.2746 23.517 853.18)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#0ff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#00d1f7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#0079e8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    style: {
      stopColor: "#0056e3"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 0.027,
    cy: 48,
    r: 1.032,
    gradientTransform: "matrix(17.9995 0 0 -19.6149 23.6 965.416)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#0ff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#00d1f7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#0079e8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    style: {
      stopColor: "#0056e3"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M7 5.4h34.1v37.1H7z"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 5.4,
    width: 34.1,
    height: 37.1,
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M24.1 21.4c.3 0 .7-.2.9-.4l4.9-6.5c.6-.7.9-.9 1.6-.9.5 0 1.2.4 1.2 1.2 0 .4-.1.8-.5 1.2l-5.8 7.1c-.3.4-.3 1 0 1.4l6.1 7.5c.2.3.5.7.5 1.2 0 .8-.6 1.4-1.4 1.4-.6 0-1-.2-1.4-.8l-5.3-7c-.2-.3-.5-.4-.9-.4-.3 0-.7.2-.9.4l-5.3 6.9c-.6.7-.9.9-1.6.9-.5 0-1.2-.4-1.2-1.2 0-.4.1-.8.5-1.2l6.1-7.5c.3-.4.3-1 0-1.4l-5.8-7.1c-.2-.3-.5-.7-.5-1.2 0-.8.6-1.4 1.4-1.4.6 0 1 .2 1.4.8l5 6.6c.3.2.6.4 1 .4zm4.1-8.3s-.1 0 0 0l-4.1 5.4L20 13c-.6-.8-1.5-1.7-3.2-1.7-1 0-1.9.4-2.5 1-.7.7-1 1.6-1 2.5 0 .8.3 1.7 1 2.5l5.2 6.4-5.6 6.9c-.7.8-1 1.7-1 2.6 0 1 .4 1.8 1.1 2.5.6.6 1.5.9 2.3.9 1.7 0 2.6-.9 3.3-1.8l4.4-5.7 4.5 5.9c.6.8 1.5 1.7 3.2 1.7 1 0 1.9-.4 2.5-1 .7-.7 1-1.6 1-2.5 0-.8-.3-1.7-1-2.5l-5.6-6.8 5.2-6.4c.7-.8 1-1.7 1-2.6 0-1-.4-1.8-1.1-2.5-.6-.6-1.5-.9-2.3-.9-1.6-.2-2.6.7-3.2 1.6M24.9 16l2.6-3.4c.8-1 1.9-2.1 3.9-2.1 2.3 0 4.1 1.9 4.1 4.2 0 1.1-.4 2.1-1.1 3.1l-4.3 5.3c-.2.2-.2.4-.2.7 0 .2.1.5.2.7l4.6 5.7c.8.9 1.2 2 1.2 3 0 2.4-1.9 4.3-4.3 4.3-1.6 0-2.8-.6-3.8-2l-3-3.9c-.2-.3-.5-.4-.9-.4-.3 0-.7.2-.9.4l-2.9 3.8c-.8 1-1.9 2.1-3.9 2.1-2.3 0-4.1-1.9-4.1-4.2 0-1.1.4-2.1 1.1-3.1l4.6-5.7c.2-.2.2-.4.2-.7 0-.2-.1-.5-.2-.7l-4.3-5.2c-.8-.9-1.2-2-1.2-3 0-2.4 1.9-4.3 4.3-4.3 1.6 0 2.8.6 3.8 2l2.6 3.5c.2.3.5.4.9.4.5 0 .8-.2 1-.5m.9-4.7-1.7 2.3-1.8-2.4c-1.4-1.9-3.3-2.8-5.5-2.8-3.6 0-6.5 2.9-6.5 6.5 0 1.5.6 3 1.6 4.4l3.7 4.5-4.1 5c-1.1 1.4-1.6 2.8-1.6 4.4 0 3.5 2.8 6.3 6.3 6.3s5.1-2.2 5.6-2.9l2.1-2.7 2.1 2.8c1.4 1.9 3.3 2.8 5.5 2.8 3.6 0 6.5-2.9 6.5-6.5 0-1.5-.6-3-1.6-4.4l-4.1-5 3.7-4.5c1.1-1.4 1.6-2.8 1.6-4.4 0-3.5-2.8-6.3-6.3-6.3-3.3 0-4.9 2.2-5.5 2.9m-1.7.3c.3 0 .7-.2.9-.4l.2-.3c1.7-2.1 3.8-3.2 6.2-3.2 3.9 0 7.1 3.2 7.1 7.1 0 1.8-.6 3.4-1.8 4.9L34 23.1c-.2.2-.2.4-.2.7 0 .2.1.5.2.7l3.1 3.8c1.2 1.5 1.8 3.2 1.8 4.9 0 2-.8 3.8-2.1 5.2-1.4 1.4-3.2 2.1-5.2 2.1-2.5 0-4.6-1.1-6.2-3.1l-.6-.8c-.2-.3-.5-.4-.9-.4-.3 0-.7.2-.9.4l-.6.8c-1.7 2.1-3.8 3.2-6.2 3.2-3.9 0-7.1-3.2-7.1-7.1 0-1.8.6-3.4 1.8-4.9l3.1-3.9c.2-.2.2-.4.2-.7 0-.2-.1-.5-.2-.7l-2.8-3.4C10 18.4 9.4 16.7 9.4 15c0-2 .8-3.8 2.1-5.2 1.4-1.4 3.2-2.1 5.2-2.1 2.5 0 4.6 1.1 6.1 3.1l.3.4c.3.2.6.4 1 .4zm7.3-6.2c-2.9 0-5.3 1.1-7.3 3.3-1.9-2.2-4.4-3.3-7.3-3.3-2.6 0-4.9 1-6.7 2.8-1.8 1.8-2.8 4.2-2.8 6.7 0 2.2.8 4.4 2.3 6.2l2.2 2.7-2.5 3.1-.1.1C7.7 28.9 7 31 7 33.3c0 5.1 4.2 9.3 9.3 9.3 3 0 5.6-1.3 7.7-3.7 2 2.4 4.6 3.7 7.7 3.7 2.5 0 4.9-1 6.7-2.8 1.8-1.8 2.8-4.2 2.8-6.7 0-2.2-.8-4.4-2.3-6.2l-2.6-3.1 2.2-2.7.1-.1c1.5-1.9 2.3-4 2.3-6.3-.2-5.1-4.3-9.3-9.5-9.3Z"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#accddc",
      fillOpacity: 1,
      strokeWidth: 1.05263
    },
    d: "M40 13H30V3Z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 1.5,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f0f0f0",
      fillOpacity: 1,
      stroke: "#b8b8b8",
      strokeWidth: 1.5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M40 45H8V3h22l10 10z",
    transform: "translate(-.177 -.059)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8b8b8",
      fillOpacity: 1,
      strokeWidth: 1.5,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    d: "M40 13H30V3Z",
    transform: "translate(-.177 -.059)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9 42V12h30v30z",
    style: {
      fontFamily: "none",
      mixBlendMode: "normal",
      fill: "none",
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.174419,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeDashoffset: 0
    }
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)",
    transform: "matrix(.63502 0 0 .63502 8.496 11.238)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#c)"
    },
    d: "M24.1 21.4c.3 0 .7-.2.9-.4l4.9-6.5c.6-.7.9-.9 1.6-.9.5 0 1.2.4 1.2 1.2 0 .4-.1.8-.5 1.2l-5.8 7.1c-.3.4-.3 1 0 1.4l6.1 7.5c.2.3.5.7.5 1.2 0 .8-.6 1.4-1.4 1.4-.6 0-1-.2-1.4-.8l-5.3-7c-.2-.3-.5-.4-.9-.4-.3 0-.7.2-.9.4l-5.3 6.9c-.6.7-.9.9-1.6.9-.5 0-1.2-.4-1.2-1.2 0-.4.1-.8.5-1.2l6.1-7.5c.3-.4.3-1 0-1.4l-5.8-7.1c-.2-.3-.5-.7-.5-1.2 0-.8.6-1.4 1.4-1.4.6 0 1 .2 1.4.8l5 6.6c.3.2.6.4 1 .4zm4.1-8.3s-.1 0 0 0l-4.1 5.4L20 13c-.6-.8-1.5-1.7-3.2-1.7-1 0-1.9.4-2.5 1-.7.7-1 1.6-1 2.5 0 .8.3 1.7 1 2.5l5.2 6.4-5.6 6.9c-.7.8-1 1.7-1 2.6 0 1 .4 1.8 1.1 2.5.6.6 1.5.9 2.3.9 1.7 0 2.6-.9 3.3-1.8l4.4-5.7 4.5 5.9c.6.8 1.5 1.7 3.2 1.7 1 0 1.9-.4 2.5-1 .7-.7 1-1.6 1-2.5 0-.8-.3-1.7-1-2.5l-5.6-6.8 5.2-6.4c.7-.8 1-1.7 1-2.6 0-1-.4-1.8-1.1-2.5-.6-.6-1.5-.9-2.3-.9-1.6-.2-2.6.7-3.2 1.6M24.9 16l2.6-3.4c.8-1 1.9-2.1 3.9-2.1 2.3 0 4.1 1.9 4.1 4.2 0 1.1-.4 2.1-1.1 3.1l-4.3 5.3c-.2.2-.2.4-.2.7 0 .2.1.5.2.7l4.6 5.7c.8.9 1.2 2 1.2 3 0 2.4-1.9 4.3-4.3 4.3-1.6 0-2.8-.6-3.8-2l-3-3.9c-.2-.3-.5-.4-.9-.4-.3 0-.7.2-.9.4l-2.9 3.8c-.8 1-1.9 2.1-3.9 2.1-2.3 0-4.1-1.9-4.1-4.2 0-1.1.4-2.1 1.1-3.1l4.6-5.7c.2-.2.2-.4.2-.7 0-.2-.1-.5-.2-.7l-4.3-5.2c-.8-.9-1.2-2-1.2-3 0-2.4 1.9-4.3 4.3-4.3 1.6 0 2.8.6 3.8 2l2.6 3.5c.2.3.5.4.9.4.5 0 .8-.2 1-.5m.9-4.7-1.7 2.3-1.8-2.4c-1.4-1.9-3.3-2.8-5.5-2.8-3.6 0-6.5 2.9-6.5 6.5 0 1.5.6 3 1.6 4.4l3.7 4.5-4.1 5c-1.1 1.4-1.6 2.8-1.6 4.4 0 3.5 2.8 6.3 6.3 6.3s5.1-2.2 5.6-2.9l2.1-2.7 2.1 2.8c1.4 1.9 3.3 2.8 5.5 2.8 3.6 0 6.5-2.9 6.5-6.5 0-1.5-.6-3-1.6-4.4l-4.1-5 3.7-4.5c1.1-1.4 1.6-2.8 1.6-4.4 0-3.5-2.8-6.3-6.3-6.3-3.3 0-4.9 2.2-5.5 2.9m-1.7.3c.3 0 .7-.2.9-.4l.2-.3c1.7-2.1 3.8-3.2 6.2-3.2 3.9 0 7.1 3.2 7.1 7.1 0 1.8-.6 3.4-1.8 4.9L34 23.1c-.2.2-.2.4-.2.7 0 .2.1.5.2.7l3.1 3.8c1.2 1.5 1.8 3.2 1.8 4.9 0 2-.8 3.8-2.1 5.2-1.4 1.4-3.2 2.1-5.2 2.1-2.5 0-4.6-1.1-6.2-3.1l-.6-.8c-.2-.3-.5-.4-.9-.4-.3 0-.7.2-.9.4l-.6.8c-1.7 2.1-3.8 3.2-6.2 3.2-3.9 0-7.1-3.2-7.1-7.1 0-1.8.6-3.4 1.8-4.9l3.1-3.9c.2-.2.2-.4.2-.7 0-.2-.1-.5-.2-.7l-2.8-3.4C10 18.4 9.4 16.7 9.4 15c0-2 .8-3.8 2.1-5.2 1.4-1.4 3.2-2.1 5.2-2.1 2.5 0 4.6 1.1 6.1 3.1l.3.4c.3.2.6.4 1 .4zm7.3-6.2c-2.9 0-5.3 1.1-7.3 3.3-1.9-2.2-4.4-3.3-7.3-3.3-2.6 0-4.9 1-6.7 2.8-1.8 1.8-2.8 4.2-2.8 6.7 0 2.2.8 4.4 2.3 6.2l2.2 2.7-2.5 3.1-.1.1C7.7 28.9 7 31 7 33.3c0 5.1 4.2 9.3 9.3 9.3 3 0 5.6-1.3 7.7-3.7 2 2.4 4.6 3.7 7.7 3.7 2.5 0 4.9-1 6.7-2.8 1.8-1.8 2.8-4.2 2.8-6.7 0-2.2-.8-4.4-2.3-6.2l-2.6-3.1 2.2-2.7.1-.1c1.5-1.9 2.3-4 2.3-6.3-.2-5.1-4.3-9.3-9.5-9.3Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st3",
    mask: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#e)"
    },
    d: "M41 5.4H7v37.1h34z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileNuix);
export default __webpack_public_path__ + "static/media/fileNuix.9702bb25745cf6884e126a09381c0135.svg";
export { ForwardRef as ReactComponent };